import { useMutation, useQueryClient } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import { putUserNotificationsDismissAll } from "Notifications/Api/notificationApi";
import { NOTIFICATIONS_QUERY_KEYS } from "Notifications/Api/Queries/queryKeys";

export function useDismissAllMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(() => putUserNotificationsDismissAll()),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: NOTIFICATIONS_QUERY_KEYS.all,
      });
    },
  });
}
